import React, { useEffect, useState, useRef } from "react";
import { Button, ButtonCol, Form, Modal, Row, Col } from "react-bootstrap";

const PaymentCompleteModal = ({ show, onHide, paymentData, customer,onViewDetails }) => {
  return (
    <Modal size="xl" show={show} onHide={onHide} backdrop={"static"}>
      <Modal.Header>
        <Modal.Title style={{ fontWeight: "bold" }}>Payment Successful</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <Col>
              {" "}
              <h4 className="fs-2 fw-bold">Patient Details</h4>
            </Col>
          </Col>
          <Col>
            <Col>
              {" "}
              <h4 className="fs-2 fw-bold ">Order Details</h4>
            </Col>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <Col>
              <h5 className="fs-2 fw-bold mb-2 mt-1">
                {" "}
                {customer?.firstName} {customer?.lastName}
              </h5>
            </Col>
            <Col>
              <h5 className="fs-2 fw-bold mb-2 mt-1">{customer.street}</h5>
            </Col>
            <Col>
              <h5 className="fs-2 fw-bold mb-2 mt-1">{customer.apartment}</h5>
            </Col>
            <Col>
              <h5 className="fs-2 fw-bold mb-2 mt-1">
                {customer.city} ,{customer.state},{customer.zipCode}
              </h5>
            </Col>
          </Col>
          <Col>
            {paymentData?.plannedProducts?.map((product, index) => {
              return (
                <Col>
                  <Row>
                    {" "}
                    <Col>
                      <h5 className="fs-2 fw-bold mb-2 mt-1">
                        {" "}
                        {product.qty} X {product.name ? product.name : product.slug}
                      </h5>
                    </Col>
                    <Col>
                      <h5 className="fs-2 fw-bold mb-2 mt-1 text-right"> $ {product.unitPrice * product.qty}</h5>
                    </Col>
                  </Row>
                </Col>
              );
            })}
            <hr />
            <Col>
              <Row className="justify-content-between">
                <Col className="flex-end">
                  {" "}
                  <h5 className="fs-2 fw-bold mb-2 mt-1">Sub Total</h5>
                </Col>
                <Col className="text-right">
                  {" "}
                  <h5 className="fs-2 fw-bold mb-2 mt-1">${paymentData?.netTotalUnpaid}</h5>
                </Col>
              </Row>
              <Row className="justify-content-between">
                <Col className="flex-end">
                  {" "}
                  <h5 className="fs-2 fw-bold mb-2 mt-1">Tax</h5>
                </Col>
                <Col className="text-right">
                  {" "}
                  <h5 className="fs-2 fw-bold mb-2 mt-1"> $ {paymentData?.taxUnPaid || "0"}</h5>
                </Col>
              </Row>
              <Row className="justify-content-between">
                <Col className="flex-end">
                  {" "}
                  <h5 className="fs-2 fw-bold mb-2 mt-1">Total</h5>
                </Col>
                <Col className="text-right">
                  {" "}
                  <h5 className="fs-2 fw-bold mb-2 mt-1">${paymentData?.grossTotalUnpaid}</h5>
                </Col>
              </Row>
            </Col>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={onViewDetails}>
          View Details
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentCompleteModal;
